import { render, staticRenderFns } from "./formCheck.vue?vue&type=template&id=1072c815"
import script from "./formCheck.vue?vue&type=script&lang=js"
export * from "./formCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports